import { Component,Input, OnInit } from '@angular/core';
import { ResponseData } from 'src/app/service/model/response.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubmittedOrderPopupComponent } from '../../chart-popup/submitted-order-popup/submitted-order-popup.component';
@Component({
  selector: 'app-submited-order-current-year',
  templateUrl: './submited-order-current-year.component.html',
  styleUrls: ['./submited-order-current-year.component.scss']
})
export class SubmitedOrderCurrentYearComponent  {
@Input() item!: ResponseData;
currentYear=new Date("YYYY");
// public barChartOptions:any = {
//     scaleShowVerticalLines: false,
//     responsive: true
//   };

  public barChartOptions = {
    scales: {
      xAxes: [{ 
        categoryPercentage: 0.7,   // default ~0.8; lower makes bars wider
        barPercentage: 0.9,
        ticks: { beginAtZero: true }
      }]
      // ,
      // yAxes: [{ ticks: { beginAtZero: true } }]
    },
    elements: {
      rectangle: {
        minBarLength: 8,
        borderWidth: 1
      }
    },
    // ... tooltips/hover from above
  };
    chartData: number[]=[];
    public barChartLabels:string[] =[]
    public barChartData:any[] =[];
   
    public barChartType:string = 'bar';
    //public barChartLegend:boolean = true;

    public barChartColors:Array<any> = [
    {
      backgroundColor: '#74acac',
      borderColor: '#346d68',
      pointBackgroundColor: 'rgba(105,159,177,1)',
      pointBorderColor: '#fafafa',
      pointHoverBackgroundColor: '#fafafa',
      pointHoverBorderColor: 'rgba(105,159,177)'
    }
  ];
  constructor(private modalService: NgbModal) { }

ngAfterViewInit() {
   this.CreateChart();
}

 CreateChart()
  {
    for (let i = 0; i < this.item.data.dashboardMonthlySubmittedOrdersChart.length; i++) {          
    
          this.barChartLabels.push(this.item.data.dashboardMonthlySubmittedOrdersChart[i].monthName)          
          this.chartData.push(this.item.data.dashboardMonthlySubmittedOrdersChart[i].orderCount)
    }

    this.barChartData=[{data:this.chartData,label:(new Date()).getFullYear()}];
 
  }
  
  
    // events
    public chartClicked(e:any):void {
      //console.log(e);
    }
  
    public chartHovered(e:any):void {
      //console.log(e);
    }

     OpenPopUp()
     {
        const modalRef = this.modalService.open(SubmittedOrderPopupComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
        (modalRef.componentInstance as SubmittedOrderPopupComponent).defaultChartData=this.item.data.dashboardMonthlySubmittedOrdersChart;
        
          modalRef.result.then((result) => {
            console.log(result);
          });
     } 
}
